import React, { useState } from 'react'
import { navigate } from 'gatsby'
import { useCombobox } from 'downshift'
import Results from './Results'
import useSearch from './useSearch'
import { MdSearch } from 'react-icons/md'

const hasSelectedItemAndSlug = changes => changes?.selectedItem?.slug !== undefined

export default function Search({ closeModal, index, store }) {
  const [value] = useState()

  const [results, search] = useSearch(index, store)

  const [inputItems, setInputItems] = useState(results)

  const { isOpen, getLabelProps, getMenuProps, getInputProps, highlightedIndex, getItemProps } =
    useCombobox({
      selectedItem: value,
      defaultHighlightedIndex: 0,
      items: inputItems,
      onInputValueChange: ({ inputValue }) => {
        if (typeof inputValue === 'string' && inputValue.length > 0) {
          search(inputValue)
          if (Array.isArray(results)) setInputItems(results)
        } else if (inputValue.length === 0) {
          setInputItems([])
        }
      },
      onSelectedItemChange: e => {
        if (hasSelectedItemAndSlug(e)) {
          closeModal && closeModal()
          navigate(e.selectedItem.slug)
        }
      },
    })
  return (
    <div
      className={`relative w-full rounded-lg border shadow-lg 
      bg-[color:var(--xstyled-colors-control-background)]`}
    >
      <div className="relative">
        <label {...getLabelProps()} hidden>
          Search the site
        </label>
        <input
          {...getInputProps()}
          className={`block w-full py-3 pl-10 pr-6 ${
            isOpen ? 'border-b' : 'rounded-b-lg'
          } leading-normal rounded-t-lg outline-none appearance-none transition-width duration-100 ease-in-out z-0 
          bg-[color:var(--xstyled-colors-control-background)] 
          focus:outline-0`}
          autoFocus={true}
          value={value}
          placeholder="Search..."
        />
        <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
          <MdSearch className="w-4 h-4 pointer-events-none fill-current"></MdSearch>
        </div>
      </div>
      <ul
        {...getMenuProps()}
        className={`w-full overflow-scroll max-h-[80vh] rounded-b-lg appearance-none bg-[color:var(--xstyled-colors-control-background)] focus:outline-0`}
      >
        {isOpen && (
          <>
            <Results
              inputItems={inputItems}
              getItemProps={getItemProps}
              highlightedIndex={highlightedIndex}
            />
            {isOpen && inputItems.length === 0 ? <li className="p-4">No results found</li> : null}
          </>
        )}
      </ul>
    </div>
  )
}
